import React from 'react'
import {useSelector} from 'react-redux';
import {Redirect, Route} from 'react-router-dom'
import {ROUTES} from '../db/models/const';
import {selectRole} from '../slices/profile';

export const PublicRoute = ({children, ...rest}) => {
    let role = useSelector(selectRole);

    return (
        <Route
            {...rest}
            render={({location}) =>
                !role ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: ROUTES.ME,
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
}
